'use strict';

/**
 * @module JSON Web Algorithms (JWA)
 */
var JWA = require('./JWA');

/**
 * Export
 */
module.exports = {
  JWA: JWA
};


//////////////////
// WEBPACK FOOTER
// ./~/@trust/jwa/lib/index.js
// module id = 7
// module chunks = 0